<template>
  <div class="not_found">
    <div class="error_message">
      アクセスしようとしたページは、権限がないため表示できません。
    </div>
    <div>
      <v-btn
        v-if="
          $hasAllRequiredPermission(
            ['DASHBOARD:READ'],
            $store.state.auth.loginInfo
          )
        "
        class="blue white--text"
        depressed=""
        @click="onClickGoToTopPage()"
        >トップページへ</v-btn
      >
      <v-btn v-else class="blue white--text" depressed="" @click="logout()"
        >ログアウト</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'forbidden',
  methods: {
    onClickGoToTopPage() {
      if (
        this.$hasAllRequiredPermission(
          ['DASHBOARD:SELECT_COMPANY', 'DASHBOARD:READ'],
          this.$store.state.auth.loginInfo
        )
      ) {
        if (this.$store.state.auth.selectedCompanyHash) {
            // planが個別分析のみかどうかで飛ぶ先のタブを変える
            if (this.$store.state.auth.selectedCompanyContracts) {
              if (
                this.$store.state.auth.selectedCompanyContracts.singleAnalysisPlans.length > 0 &&
                this.$store.state.auth.selectedCompanyContracts.generalAnalysisPlans.length == 0 &&
                this.$store.state.auth.selectedCompanyContracts.eventAnalysisPlans.length == 0
              ) {
                this.$router.push('/dashboard/productAnalysis')
              } else {
                this.$router.push('/dashboard/general')
              }
            } else {
              this.$router.push('/dashboard/general')
            }
        } else {
          this.$router.push({path: '/companySelect'})
        }
      } else {
        // planが個別分析のみかどうかで飛ぶ先のタブを変える
        if (this.$store.state.auth.selectedCompanyContracts) {
          if (
            this.$store.state.auth.selectedCompanyContracts.singleAnalysisPlans.length > 0 &&
            this.$store.state.auth.selectedCompanyContracts.generalAnalysisPlans.length == 0 &&
            this.$store.state.auth.selectedCompanyContracts.eventAnalysisPlans.length == 0
          ) {
            this.$router.push('/dashboard/productAnalysis')
          } else {
            this.$router.push('/dashboard/general')
          }
        } else {
          this.$router.push('/dashboard/general')
        }
      }
    },
    async logout() {
      await this.$axios.delete('/users/session')
      .then(()=> {
        this.$store.dispatch("auth/logout")
        this.$store.dispatch("filter/clearFilteringConditions")
        this.$router.push({path: '/login', query: {logout: true}})
      })
      .catch(err => {
        console.log(err);
      })
    },
  }
}
</script>

<style scoped>
.error_message {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: #343a3f;
  margin: 30px 30px;
}
</style>

